export default __webpack_public_path__ + "images/8124d6c1b08999a1af96512e44afb6d3-educators.jpg";